/**
 * Energie-Bilanz-Berechnung für einen Planeten.
 * Supply (Solar-Kollektor) vs. Demand (Fabriken) → Produktions-Modifier.
 */
import type { BuildingType } from '../config/BuildingTypes';
import { BUILDING_DEFS } from '../config/BuildingsConfig';
import { solarOutput, factoryEnergy } from './BuildingFormulas';

export interface EnergyBalanceInfo {
  /** Solarproduktion/s */
  supply: number;
  /** Gesamtverbrauch/s aller Fabriken */
  demand: number;
  /** supply - demand */
  balance: number;
  /** 0–1 Produktions-Modifier (1 = volle Produktion) */
  modifier: number;
  /** Anzahl aktiver Fabriken (level > 0, ohne Solar) */
  consumers: number;
}

const FACTORY_TYPES: readonly BuildingType[] = [
  'feronium_mine', 'chrysalium_burner', 'neurogel_extractor',
];

export function calcEnergyBalance(
  levels: Map<BuildingType, number>,
): EnergyBalanceInfo {
  const collectorLevel = levels.get('solar_collector') ?? 0;
  const collectorDef = BUILDING_DEFS.solar_collector;
  const supply = solarOutput(collectorLevel, collectorDef.baseRate);

  let demand = 0;
  let consumers = 0;
  for (const type of FACTORY_TYPES) {
    const lv = levels.get(type) ?? 0;
    if (lv > 0) {
      demand += factoryEnergy(lv, BUILDING_DEFS[type].baseEnergy);
      consumers++;
    }
  }

  const balance = supply - demand;

  let modifier = 1;
  if (demand > 0) {
    modifier = Math.max(0, Math.min(1, supply / demand));
  }

  return { supply, demand, balance, modifier, consumers };
}
